/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibrarydescription2Inputs */

const en_medialibrarydescription2 = /** @type {(inputs: Medialibrarydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All your AI-generated assets - download them any time, free.`)
};

const de_medialibrarydescription2 = /** @type {(inputs: Medialibrarydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle deine KI-erstellten Inhalte – jederzeit kostenlos herunterladbar.`)
};

/**
* | output |
* | --- |
* | "All your AI-generated assets - download them any time, free." |
*
* @param {Medialibrarydescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibrarydescription2 = /** @type {((inputs?: Medialibrarydescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibrarydescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibrarydescription2(inputs)
	return de_medialibrarydescription2(inputs)
});
export { medialibrarydescription2 as "mediaLibraryDescription" }